import React from "react";
import AppleLocalNav from "../../AppleLocalNav";
export default function DesignSubNav(){ return <AppleLocalNav title="Design" overview="/design" pages={[{"label":"Projects","to":"/designlist"},{"label":"Design Guidelines","to":"/guideline"}]}  />; }
